// Translations for MyLafayette Admissions public pages.
// The parent dashboard and admin panel remain in French only (internal use).
export const translations = {
  fr: {
    nav: {
      backToLafayette: "Lafayette",
      contact: "Demander un RDV",
      login: "Connexion",
      logout: "Déconnexion",
      myDossier: "Mon dossier",
      admin: "Admin",
    },
    hero: {
      overline: "Rentrée 2026 · Collège & Lycée international",
      titleLine1: "L'admission scolaire,",
      titleLine2: "simple et entièrement en ligne.",
      description: "MyLafayette Admissions permet aux familles de constituer en ligne le dossier d'admission à Lafayette International School, déposer les pièces justificatives — dont la preuve de virement des frais — et suivre la validation par l'administration. Le tout depuis un seul espace, sans courrier.",
      ctaRdv: "Demander un rendez-vous",
      ctaAccess: "J'ai déjà un accès",
      badgeAccess: "Accès sur invitation",
      badgeDocs: "11 pièces à fournir",
      badgePayment: "Frais par virement",
    },
    steps: {
      overline: "Le parcours",
      title1: "4 étapes,",
      title2: "zéro paperasse",
      description: "Plus besoin de courir entre le secrétariat et la poste : tout se passe en ligne, vous gardez la trace de chaque étape.",
      s1Title: "Prise de contact",
      s1Desc: "Remplissez le formulaire de contact du site officiel avec quelques informations sur votre enfant.",
      s2Title: "Rendez-vous d'admission",
      s2Desc: "L'administration vous reçoit pour échanger sur le projet pédagogique et présenter Lafayette.",
      s3Title: "Invitation par email",
      s3Desc: "À l'issue du RDV, vous recevez un lien personnel pour activer votre espace MyLafayette Admissions.",
      s4Title: "Dossier & validation",
      s4Desc: "Vous constituez le dossier en ligne (11 pièces, dont la preuve de virement des frais), l'école valide l'inscription.",
    },
    docs: {
      overline: "Pièces à fournir",
      title1: "11 pièces à téléverser,",
      title2: "vérifiées une par une.",
      description: "Chaque pièce est contrôlée par le secrétariat de Lafayette. Les frais d'inscription se règlent par virement bancaire et la **preuve de virement** fait partie du dossier à téléverser.",
      validationBadge: "Validation",
      validationTitle: "Pièce par pièce",
      validationDesc: "Notes administratives en cas de rejet pour ré-uploader.",
      facultatif: "Facultatif",
      handoutNote: "Le dossier d'inscription complet et l'IBAN de l'école vous sont remis lors du premier rendez-vous au sein de l'établissement.",
    },
    cta: {
      overline: "Prêt à rejoindre Lafayette ?",
      titlePart1: "Commencez par",
      titlePart2: "une prise de contact.",
      description: "Notre équipe d'admission vous reçoit pour un premier entretien. Vous recevrez ensuite par email votre accès personnel à MyLafayette Admissions pour constituer le dossier et téléverser la preuve de virement.",
      button: "Demander un rendez-vous",
      buttonSecondary: "Se connecter",
    },
    footer: {
      schoolFull: "Lafayette International School",
      tagline: "Collège & Lycée bilingue · Nice",
      resources: "Ressources",
      official: "Site officiel Lafayette",
      requestMeeting: "Demander un rendez-vous",
      familySpace: "Espace famille",
      aboutTitle: "À propos",
      aboutText: "MyLafayette Admissions est l'extension numérique d'inscription en ligne réservée aux familles ayant été reçues par l'administration de Lafayette International School.",
      rgpd: "Conforme RGPD · Données hébergées en Europe",
      copyright: "Lafayette International School — Tous droits réservés",
    },
    docList: {
      assurance_rc: "Assurance scolaire / Responsabilité civile",
      certificat_naissance: "Certificat de naissance",
      certificat_radiation: "Certificat de radiation",
      bulletins: "Bulletins scolaires (3 derniers)",
      id_pere: "Pièce d'identité — Père",
      id_mere: "Pièce d'identité — Mère",
      id_enfant: "Pièce d'identité — Enfant",
      vaccinations: "Carnet de vaccination",
      iban: "IBAN",
      preuve_virement: "Preuve de virement des frais d'inscription",
      dossier_signe: "Dossier d'inscription complet signé",
    },
    login: {
      overline: "Connexion",
      title: "Bon retour parmi nous.",
      subtitle: "Accédez à votre dossier d'inscription et suivez son avancement.",
      google: "Continuer avec Google",
      or: "ou",
      email: "Email",
      emailPlaceholder: "parent@email.com",
      password: "Mot de passe",
      submit: "Se connecter",
      submitting: "Connexion…",
      noAccount: "Pas encore de compte ?",
      createAccount: "Créer un compte",
      invitationInfo: "L'accès à MyLafayette est strictement sur invitation. Si vous n'avez pas encore reçu votre lien d'activation par email, contactez l'administration après votre premier rendez-vous : collegelyceelafayette@gmail.com",
      sideOverline: "Espace parents",
      sideTitle1: "Reprenez votre dossier",
      sideTitle2: "là où vous l'aviez laissé.",
    },
    register: {
      overline: "Accès sur invitation",
      title: "L'inscription se fait après un premier rendez-vous.",
      intro: "L'accès à MyLafayette Admissions est",
      introBold: "réservé aux familles ayant été reçues",
      introEnd: "par l'administration de Lafayette International School. Le parcours est le suivant :",
      step1Title: "Prise de contact",
      step1Desc: "Remplissez le formulaire de contact sur le site officiel de l'école avec quelques informations sur votre enfant.",
      step2Title: "Rendez-vous d'admission",
      step2Desc: "L'administration vous propose un entretien (en présentiel ou en visio) pour échanger sur le projet pédagogique de votre enfant.",
      step3Title: "Invitation par email",
      step3Desc1: "À l'issue du RDV, vous recevez un email contenant un",
      step3Desc2: "lien d'invitation personnel",
      step3Desc3: "pour activer votre espace et constituer votre dossier en ligne.",
      contactBox: "Demander un rendez-vous",
      gotoContact: "Aller au formulaire de contact",
      alreadyInvited: "Déjà invité ? Se connecter",
      secureNote: "Ce processus protège vos données et garantit un suivi personnalisé.",
      sideOverline: "Lafayette International School",
      sideTitle1: "L'excellence française,",
      sideTitle2: "une ouverture internationale.",
      sideSub: "Une admission rigoureuse, un accompagnement sur-mesure.",
    },
    invite: {
      overline: "Invitation Lafayette",
      title: "Activez votre espace famille.",
      welcome: "Bienvenue",
      subtitle: "Suite à votre rendez-vous avec l'administration, voici votre accès personnel à MyLafayette Admissions.",
      openedFor: "Dossier ouvert pour",
      email: "Email",
      emailHelp: "Email lié à votre invitation — non modifiable.",
      name: "Nom complet du référent",
      password: "Mot de passe",
      submit: "Activer mon espace",
      submitting: "Activation…",
      footer: "Vous recevez ce lien parce qu'un rendez-vous d'admission a eu lieu avec l'établissement. Il n'est pas possible de créer un compte sans cette invitation.",
      verifying: "Vérification de l'invitation…",
      invalidTitle: "Invitation invalide",
      invalidNote: "Si vous pensez qu'il s'agit d'une erreur, contactez l'administration de Lafayette International School à",
      home: "Retour à l'accueil",
      already: "Vous êtes déjà connecté",
      alreadyDesc: "Cette invitation s'utilise depuis un compte non connecté.",
      goSpace: "Aller à mon espace",
      sideTitle1: "Bienvenue dans",
      sideTitle2: "votre nouveau chapitre.",
    },
    dash: {
      overline: "Espace parent",
      hello: "Bonjour,",
      sub: "Suivez l'état du dossier d'inscription et complétez les étapes manquantes.",
      step1: "Informations élève",
      step2: "Parents & foyer",
      step3: "Pièces justificatives",
      step4: "Vérification & soumission",
      previous: "Précédent",
      next: "Suivant",
      save: "Enregistrer",
      saving: "Enregistrement…",
      submit: "Soumettre pour validation",
      lockedSubmitted: "Dossier déjà soumis — modification impossible.",
      missing: "manquant :",
      complete: "complètes",
      completes: "complets",
      reviewIntro: "Vérifiez que toutes les étapes sont complètes avant de soumettre votre dossier pour validation.",
      reviewStudent: "Informations élève",
      reviewParents: "Parents & foyer",
      reviewDocs: "Pièces justificatives",
      privacy: "Vos données sont chiffrées et accessibles uniquement par l'administration de l'établissement.",
      uploadHere: "Téléverser",
      replace: "Remplacer",
      docFacultatif: "Facultatif",
      statusDraft: "Brouillon",
      statusSubmitted: "Soumis",
      statusValidated: "Validé",
      statusRejected: "À corriger",
      finalValidatedTitle: "Inscription confirmée",
      finalValidatedDesc: "Votre dossier a été entièrement validé par l'administration de Lafayette International School. Vous recevrez prochainement par email la convocation et les informations de rentrée.",
      finalPendingTitle: "Validation administrative",
      finalPendingDesc: "Une fois votre dossier soumis avec toutes les pièces (y compris la preuve de virement des frais d'inscription), le secrétariat de Lafayette vérifie chaque pièce. Vous recevrez la confirmation d'inscription dès la validation finale.",
      rejectedTitle: "Notes de l'administration :",
      pillStatus: "Dossier",
    },
    contact: {
      overline: "Nous contacter",
      titlePart1: "Démarrons",
      titlePart2: "la conversation.",
      subtitle: "Envie d'en savoir plus sur Lafayette International School ? Remplissez le formulaire ci-dessous ou contactez-nous directement. L'administration répond sous 24 h ouvrées.",
      infoOverline: "Informations",
      infoTitle: "Lafayette International School",
      addressLabel: "Adresse",
      directions: "Itinéraire Google Maps",
      phoneLabel: "Téléphone",
      phoneHours: "Lun-Mar-Jeu-Ven : 7h30 – 18h00",
      emailLabel: "Email",
      emailReply: "Réponse sous 24 h ouvrées",
      hoursLabel: "Horaires d'accueil",
      hoursMon: "Lun, Mar, Jeu, Ven : 7h30 – 18h00",
      hoursWed: "Mercredi : 8h00 – 13h00",
      formOverline: "Formulaire de prise de contact",
      formTitle: "Demander un rendez-vous",
      formSub: "Renseignez les informations ci-dessous, notre équipe d'admission vous recontacte rapidement pour planifier un premier échange.",
      parentLabel: "Nom du parent / tuteur",
      parentPlaceholder: "Jean Dupont",
      emailFieldLabel: "Adresse email",
      phoneFieldLabel: "Téléphone",
      gradeLabel: "Niveau scolaire souhaité",
      childDobLabel: "Date de naissance de votre enfant",
      childGenderLabel: "Genre de l'enfant",
      childGenderMale: "Masculin",
      childGenderFemale: "Féminin",
      gradePlaceholder: "Sélectionner un niveau",
      messageLabel: "Message",
      messagePlaceholder: "Parlez-nous brièvement de votre enfant et de votre projet…",
      submit: "Envoyer ma demande",
      submitting: "Envoi en cours…",
      privacy: "En soumettant ce formulaire vous acceptez d'être recontacté par l'administration de Lafayette International School. Vos données ne sont pas partagées avec des tiers.",
      successTitle: "Demande envoyée ✓",
      successDesc: "Merci ! Votre demande a bien été transmise à l'administration. Vous recevrez une réponse par email sous 24 h ouvrées.",
      successToast: "Votre demande a bien été envoyée",
      backupEmailTitle: "Vous ne recevez pas de réponse ?",
      backupEmailDesc: "Par sécurité, vous pouvez aussi envoyer votre demande directement par email — votre application de messagerie s'ouvrira avec le message déjà pré-rempli.",
      backupEmailButton: "Envoyer une copie par email",
      sendAnother: "Envoyer une autre demande",
      errorRequired: "Merci de remplir les champs obligatoires (nom, email, niveau).",
      errorGeneric: "Une erreur est survenue, merci de réessayer.",
    },
  },
  en: {
    nav: {
      backToLafayette: "Lafayette",
      contact: "Schedule a Visit",
      login: "Sign in",
      logout: "Sign out",
      myDossier: "My application",
      admin: "Admin",
    },
    hero: {
      overline: "Class of 2026 · International Middle & High School",
      titleLine1: "School admission,",
      titleLine2: "simple and entirely online.",
      description: "MyLafayette Admissions lets families build their application file to Lafayette International School online, upload supporting documents — including the enrollment fee transfer receipt — and track the school's validation in real time. All from a single secure space, no mail required.",
      ctaRdv: "Schedule a Visit",
      ctaAccess: "I already have access",
      badgeAccess: "Invitation only",
      badgeDocs: "11 documents required",
      badgePayment: "Bank transfer",
    },
    steps: {
      overline: "The journey",
      title1: "4 steps,",
      title2: "zero paperwork",
      description: "No more shuttling between the school office and the post office: everything happens online, and you keep track of every step.",
      s1Title: "Get in touch",
      s1Desc: "Fill out the contact form on the official Lafayette website with a few details about your child.",
      s2Title: "Admissions meeting",
      s2Desc: "The administration meets you to discuss your child's educational project and introduce Lafayette.",
      s3Title: "Email invitation",
      s3Desc: "After the meeting, you receive a personal link to activate your MyLafayette Admissions space.",
      s4Title: "Application & validation",
      s4Desc: "You complete the file online (11 documents, including the enrollment-fee transfer receipt), the school validates the enrollment.",
    },
    docs: {
      overline: "Documents required",
      title1: "11 documents to upload,",
      title2: "verified one by one.",
      description: "Each document is checked by Lafayette's administration. Enrollment fees are paid by bank transfer and the **transfer receipt** is part of the file you upload.",
      validationBadge: "Validation",
      validationTitle: "Document by document",
      validationDesc: "Administrative notes in case of rejection so you can re-upload.",
      facultatif: "Optional",
      handoutNote: "The complete enrollment file and the school's IBAN are handed to you in person during the first meeting at the school.",
    },
    cta: {
      overline: "Ready to join Lafayette?",
      titlePart1: "Start with",
      titlePart2: "a first conversation.",
      description: "Our admissions team meets you for a first interview. You'll then receive by email your personal access to MyLafayette Admissions to assemble the file and upload the transfer receipt.",
      button: "Schedule a Visit",
      buttonSecondary: "Sign in",
    },
    footer: {
      schoolFull: "Lafayette International School",
      tagline: "Bilingual Middle & High School · Nice",
      resources: "Resources",
      official: "Official Lafayette website",
      requestMeeting: "Schedule a Visit",
      familySpace: "Family space",
      aboutTitle: "About",
      aboutText: "MyLafayette Admissions is the digital admissions extension reserved for families who have been received by Lafayette International School's administration.",
      rgpd: "GDPR compliant · Data hosted in Europe",
      copyright: "Lafayette International School — All rights reserved",
    },
    docList: {
      assurance_rc: "School insurance / Civil liability",
      certificat_naissance: "Birth certificate",
      certificat_radiation: "Transfer release certificate",
      bulletins: "School reports (last 3)",
      id_pere: "ID — Father",
      id_mere: "ID — Mother",
      id_enfant: "ID — Child",
      vaccinations: "Vaccination record",
      iban: "Bank account (IBAN)",
      preuve_virement: "Enrollment fee transfer receipt",
      dossier_signe: "Signed complete application form",
    },
    login: {
      overline: "Sign in",
      title: "Welcome back.",
      subtitle: "Access your application file and follow its progress.",
      google: "Continue with Google",
      or: "or",
      email: "Email",
      emailPlaceholder: "parent@email.com",
      password: "Password",
      submit: "Sign in",
      submitting: "Signing in…",
      noAccount: "No account yet?",
      createAccount: "Create an account",
      invitationInfo: "Access to MyLafayette is strictly by invitation. If you haven't received your activation link by email yet, please contact the administration after your first meeting: collegelyceelafayette@gmail.com",
      sideOverline: "Family space",
      sideTitle1: "Pick up your application",
      sideTitle2: "right where you left off.",
    },
    register: {
      overline: "Invitation only",
      title: "Registration follows a first meeting.",
      intro: "Access to MyLafayette Admissions is",
      introBold: "reserved for families who have been received",
      introEnd: "by Lafayette International School's administration. The process is as follows:",
      step1Title: "Get in touch",
      step1Desc: "Fill out the contact form on the school's official website with a few details about your child.",
      step2Title: "Admissions meeting",
      step2Desc: "The administration offers you an interview (in person or remote) to discuss your child's educational project.",
      step3Title: "Email invitation",
      step3Desc1: "After the meeting, you receive an email containing a",
      step3Desc2: "personal invitation link",
      step3Desc3: "to activate your space and assemble your file online.",
      contactBox: "Schedule a Visit",
      gotoContact: "Go to the contact form",
      alreadyInvited: "Already invited? Sign in",
      secureNote: "This process protects your data and ensures personalized follow-up.",
      sideOverline: "Lafayette International School",
      sideTitle1: "French excellence,",
      sideTitle2: "international openness.",
      sideSub: "Rigorous admission, tailored support.",
    },
    invite: {
      overline: "Lafayette invitation",
      title: "Activate your family space.",
      welcome: "Welcome",
      subtitle: "Following your meeting with the administration, here is your personal access to MyLafayette Admissions.",
      openedFor: "File opened for",
      email: "Email",
      emailHelp: "Email tied to your invitation — not editable.",
      name: "Reference contact full name",
      password: "Password",
      submit: "Activate my space",
      submitting: "Activating…",
      footer: "You receive this link because an admissions meeting took place with the school. It is not possible to create an account without this invitation.",
      verifying: "Verifying invitation…",
      invalidTitle: "Invalid invitation",
      invalidNote: "If you think this is a mistake, contact Lafayette International School at",
      home: "Back to home",
      already: "You are already signed in",
      alreadyDesc: "This invitation is meant for a non-authenticated account.",
      goSpace: "Go to my space",
      sideTitle1: "Welcome to",
      sideTitle2: "your new chapter.",
    },
    dash: {
      overline: "Family space",
      hello: "Hello,",
      sub: "Track your application and complete the missing steps.",
      step1: "Student details",
      step2: "Parents & household",
      step3: "Supporting documents",
      step4: "Review & submit",
      previous: "Previous",
      next: "Next",
      save: "Save",
      saving: "Saving…",
      submit: "Submit for validation",
      lockedSubmitted: "File already submitted — editing locked.",
      missing: "missing:",
      complete: "complete",
      completes: "complete",
      reviewIntro: "Check that every step is complete before submitting your application for validation.",
      reviewStudent: "Student details",
      reviewParents: "Parents & household",
      reviewDocs: "Supporting documents",
      privacy: "Your data is encrypted and accessible only by the school administration.",
      uploadHere: "Upload",
      replace: "Replace",
      docFacultatif: "Optional",
      statusDraft: "Draft",
      statusSubmitted: "Submitted",
      statusValidated: "Validated",
      statusRejected: "To fix",
      finalValidatedTitle: "Enrollment confirmed",
      finalValidatedDesc: "Your file has been fully validated by Lafayette International School's administration. You will soon receive by email the convocation and back-to-school information.",
      finalPendingTitle: "Administrative validation",
      finalPendingDesc: "Once you submit your file with every document (including the enrollment fee transfer receipt), Lafayette's office reviews each document. You will receive enrollment confirmation upon final validation.",
      rejectedTitle: "Administration notes:",
      pillStatus: "File",
    },
    contact: {
      overline: "Get in touch",
      titlePart1: "Start the",
      titlePart2: "conversation.",
      subtitle: "Want to learn more about Lafayette International School? Fill out the form below or contact us directly. The administration replies within 24 business hours.",
      infoOverline: "Information",
      infoTitle: "Lafayette International School",
      addressLabel: "Address",
      directions: "Google Maps directions",
      phoneLabel: "Phone",
      phoneHours: "Mon-Tue-Thu-Fri: 7:30 am – 6:00 pm",
      emailLabel: "Email",
      emailReply: "Reply within 24 business hours",
      hoursLabel: "Office hours",
      hoursMon: "Mon, Tue, Thu, Fri: 7:30 am – 6:00 pm",
      hoursWed: "Wednesday: 8:00 am – 1:00 pm",
      formOverline: "Inquiry form",
      formTitle: "Schedule a visit",
      formSub: "Fill in the details below — our admissions team will get back to you shortly to schedule a first conversation.",
      parentLabel: "Parent / Guardian name",
      parentPlaceholder: "John Doe",
      emailFieldLabel: "Email address",
      phoneFieldLabel: "Phone number",
      gradeLabel: "Grade level of interest",
      childDobLabel: "Child's date of birth",
      childGenderLabel: "Child's gender",
      childGenderMale: "Male",
      childGenderFemale: "Female",
      gradePlaceholder: "Select a grade level",
      messageLabel: "Message",
      messagePlaceholder: "Tell us briefly about your child and your project…",
      submit: "Send my inquiry",
      submitting: "Sending…",
      privacy: "By submitting this form you agree to be contacted by Lafayette International School's administration. Your data is not shared with third parties.",
      successTitle: "Inquiry sent ✓",
      successDesc: "Thank you! Your inquiry has been received. You will get a reply by email within 24 business hours.",
      successToast: "Your inquiry has been sent",
      backupEmailTitle: "Not getting a reply?",
      backupEmailDesc: "As a backup, you can also send your inquiry directly by email — your mail client will open with the message pre-filled.",
      backupEmailButton: "Send a copy by email",
      sendAnother: "Send another inquiry",
      errorRequired: "Please fill in the required fields (name, email, grade).",
      errorGeneric: "An error occurred, please try again.",
    },
  },
  zh: {
    nav: {
      backToLafayette: "Lafayette",
      contact: "预约参观",
      login: "登录",
      logout: "退出登录",
      myDossier: "我的申请",
      admin: "管理",
    },
    hero: {
      overline: "2026 届 · 国际中学 & 高中",
      titleLine1: "学校入学申请,",
      titleLine2: "全程在线,轻松简便。",
      description: "MyLafayette Admissions 让家长可在线提交申请、上传所需文件(包括注册费汇款凭证),并实时跟踪 Lafayette International School 行政部门的审核进度——一个安全的平台,无需邮寄任何材料。",
      ctaRdv: "预约参观",
      ctaAccess: "我已有账户",
      badgeAccess: "仅限受邀家庭",
      badgeDocs: "需提交 11 份文件",
      badgePayment: "银行转账缴费",
    },
    steps: {
      overline: "申请流程",
      title1: "四个步骤,",
      title2: "无纸化操作",
      description: "无需在学校行政处与邮局之间来回奔波:全部线上完成,每一步均可追踪。",
      s1Title: "与我们联系",
      s1Desc: "在官方网站填写联系表,提供孩子的基本情况。",
      s2Title: "招生面谈",
      s2Desc: "学校行政团队与您进行面谈,介绍 Lafayette 的教学项目并讨论孩子的学习方向。",
      s3Title: "邮件邀请",
      s3Desc: "面谈后,您将收到一封带有个人激活链接的邮件,以开通 MyLafayette Admissions 账户。",
      s4Title: "材料与审核",
      s4Desc: "您在线提交完整申请(11 份文件,包括注册费汇款凭证),学校进行审核与确认。",
    },
    docs: {
      overline: "所需文件",
      title1: "11 份在线文件,",
      title2: "逐一审核验证。",
      description: "每份文件都由 Lafayette 行政部门审核。注册费需通过银行转账缴纳,**汇款凭证**是申请材料之一,需在线上传。",
      validationBadge: "审核",
      validationTitle: "逐份核实",
      validationDesc: "若文件被驳回,会附上管理员批注,方便您重新上传。",
      facultatif: "可选",
      handoutNote: "完整的入学申请表和学校的银行账户信息(IBAN)将在您首次到访学校的会面时当面交给您。",
    },
    cta: {
      overline: "准备好加入 Lafayette 了吗?",
      titlePart1: "从",
      titlePart2: "首次联系开始。",
      description: "我们的招生团队将为您安排一次初步面谈。之后您会通过邮件收到 MyLafayette Admissions 的个人访问链接,以便整理申请材料并上传汇款凭证。",
      button: "预约参观",
      buttonSecondary: "登录",
    },
    footer: {
      schoolFull: "Lafayette International School",
      tagline: "尼斯 · 双语中学与高中",
      resources: "资源",
      official: "Lafayette 官方网站",
      requestMeeting: "预约参观",
      familySpace: "家庭账户",
      aboutTitle: "关于我们",
      aboutText: "MyLafayette Admissions 是 Lafayette International School 的在线申请扩展平台,仅向已与学校行政部门会面的家庭开放。",
      rgpd: "符合 GDPR · 数据托管于欧盟境内",
      copyright: "Lafayette International School — 版权所有",
    },
    docList: {
      assurance_rc: "学生保险 / 民事责任险",
      certificat_naissance: "出生证明",
      certificat_radiation: "原校除名证明",
      bulletins: "学生成绩单(最近三份)",
      id_pere: "身份证件 — 父亲",
      id_mere: "身份证件 — 母亲",
      id_enfant: "身份证件 — 学生本人",
      vaccinations: "疫苗接种记录",
      iban: "银行账户(IBAN)",
      preuve_virement: "注册费汇款凭证",
      dossier_signe: "完整签字的入学申请表",
    },
    login: {
      overline: "登录",
      title: "欢迎回来。",
      subtitle: "进入您的入学申请账户,跟踪审核进度。",
      google: "使用 Google 登录",
      or: "或",
      email: "邮箱",
      emailPlaceholder: "parent@email.com",
      password: "密码",
      submit: "登录",
      submitting: "登录中…",
      noAccount: "还没有账户?",
      createAccount: "创建账户",
      invitationInfo: "MyLafayette 仅限受邀使用。如果您尚未通过邮件收到激活链接,请在首次面谈后联系学校行政部门:collegelyceelafayette@gmail.com",
      sideOverline: "家庭账户",
      sideTitle1: "继续您的申请,",
      sideTitle2: "从上次停下的地方开始。",
    },
    register: {
      overline: "仅限受邀注册",
      title: "首次面谈后方可注册。",
      intro: "MyLafayette Admissions 的访问权限",
      introBold: "仅向已与学校行政部门面谈的家庭开放",
      introEnd: ",Lafayette International School 的招生流程如下:",
      step1Title: "与我们联系",
      step1Desc: "在 Lafayette 官方网站填写联系表,提供孩子的基本情况。",
      step2Title: "招生面谈",
      step2Desc: "行政团队会安排面谈(现场或在线视频)讨论孩子的学习计划。",
      step3Title: "邮件邀请",
      step3Desc1: "面谈后,您将收到一封包含",
      step3Desc2: "个人激活链接",
      step3Desc3: "的邮件,用于开通账户并在线整理申请材料。",
      contactBox: "预约参观",
      gotoContact: "前往联系表",
      alreadyInvited: "已收到邀请?请登录",
      secureNote: "此流程旨在保护您的数据并保证一对一跟进。",
      sideOverline: "Lafayette International School",
      sideTitle1: "法兰西式严谨,",
      sideTitle2: "面向世界的开放。",
      sideSub: "严谨的招生流程,量身定制的陪伴。",
    },
    invite: {
      overline: "Lafayette 邀请",
      title: "激活您的家庭账户。",
      welcome: "欢迎",
      subtitle: "在与行政部门面谈后,以下是您进入 MyLafayette Admissions 的个人入口。",
      openedFor: "本次申请对应",
      email: "邮箱",
      emailHelp: "此邮箱已与邀请链接绑定 — 不可更改。",
      name: "联系人全名",
      password: "密码",
      submit: "激活我的账户",
      submitting: "激活中…",
      footer: "您收到此链接是因为学校已与您进行过招生面谈。未经邀请无法创建账户。",
      verifying: "正在验证邀请…",
      invalidTitle: "邀请无效",
      invalidNote: "如认为这是错误,请联系 Lafayette International School 行政部门:",
      home: "返回首页",
      already: "您已登录",
      alreadyDesc: "本邀请链接仅供未登录账户使用。",
      goSpace: "进入我的账户",
      sideTitle1: "欢迎开启",
      sideTitle2: "您的新篇章。",
    },
    dash: {
      overline: "家长空间",
      hello: "您好,",
      sub: "查看申请进度,补充未完成的步骤。",
      step1: "学生信息",
      step2: "家长 & 家庭",
      step3: "证明文件",
      step4: "核对与提交",
      previous: "上一步",
      next: "下一步",
      save: "保存",
      saving: "保存中…",
      submit: "提交以待审核",
      lockedSubmitted: "申请已提交,无法再修改。",
      missing: "尚缺:",
      complete: "完成",
      completes: "完成",
      reviewIntro: "提交前请确认所有步骤已完成。",
      reviewStudent: "学生信息",
      reviewParents: "家长 & 家庭",
      reviewDocs: "证明文件",
      privacy: "您的数据已加密,仅学校行政人员可访问。",
      uploadHere: "上传",
      replace: "替换",
      docFacultatif: "可选",
      statusDraft: "草稿",
      statusSubmitted: "已提交",
      statusValidated: "已通过",
      statusRejected: "需修改",
      finalValidatedTitle: "入学已确认",
      finalValidatedDesc: "您的申请已通过 Lafayette International School 行政部门的完整审核。您将很快收到开学通知与相关信息。",
      finalPendingTitle: "行政审核中",
      finalPendingDesc: "提交完整申请(含注册费汇款凭证)后,Lafayette 学校行政部门将逐一审核文件,审核通过后即正式确认入学。",
      rejectedTitle: "行政部门备注:",
      pillStatus: "申请",
    },
    contact: {
      overline: "联系我们",
      titlePart1: "让我们",
      titlePart2: "开始交流。",
      subtitle: "想进一步了解 Lafayette International School?请填写下方表格或直接与我们联系,行政部门将在 24 个工作时内回复。",
      infoOverline: "联系方式",
      infoTitle: "Lafayette International School",
      addressLabel: "地址",
      directions: "Google 地图路线",
      phoneLabel: "电话",
      phoneHours: "周一、二、四、五:7:30 – 18:00",
      emailLabel: "邮箱",
      emailReply: "24 小时(工作日)内回复",
      hoursLabel: "办公时间",
      hoursMon: "周一、二、四、五:7:30 – 18:00",
      hoursWed: "周三:8:00 – 13:00",
      formOverline: "咨询表",
      formTitle: "预约参观",
      formSub: "填写以下信息,招生团队将尽快与您联系以安排首次会面。",
      parentLabel: "家长 / 监护人姓名",
      parentPlaceholder: "张三",
      emailFieldLabel: "邮箱",
      phoneFieldLabel: "电话",
      gradeLabel: "意向年级",
      childDobLabel: "孩子的出生日期",
      childGenderLabel: "孩子的性别",
      childGenderMale: "男",
      childGenderFemale: "女",
      gradePlaceholder: "请选择年级",
      messageLabel: "留言",
      messagePlaceholder: "请简要介绍您的孩子和申请意向…",
      submit: "发送咨询",
      submitting: "发送中…",
      privacy: "提交即表示您同意接收 Lafayette International School 行政部门的回复。我们不会将您的信息分享给任何第三方。",
      successTitle: "咨询已发送 ✓",
      successDesc: "感谢!您的咨询已提交。我们将在 24 个工作时内通过邮件回复您。",
      successToast: "您的咨询已发送",
      backupEmailTitle: "未收到回复?",
      backupEmailDesc: "作为备用方式,您也可以直接通过邮件发送咨询 — 您的邮箱客户端将自动打开并填好内容。",
      backupEmailButton: "通过邮件发送副本",
      sendAnother: "再发送一次咨询",
      errorRequired: "请填写必填项(姓名、邮箱、年级)。",
      errorGeneric: "出现错误,请稍后重试。",
    },
  },
  ru: {
    nav: {
      backToLafayette: "Lafayette",
      contact: "Записаться на визит",
      login: "Войти",
      logout: "Выйти",
      myDossier: "Моя заявка",
      admin: "Админ",
    },
    hero: {
      overline: "Набор 2026 · Международный колледж и лицей",
      titleLine1: "Поступление в школу,",
      titleLine2: "просто и полностью онлайн.",
      description: "MyLafayette Admissions позволяет семьям онлайн собрать досье поступления в Lafayette International School, загрузить необходимые документы — включая подтверждение банковского перевода вступительного взноса — и отслеживать проверку администрацией в реальном времени. Всё в одном защищённом пространстве, без бумажной почты.",
      ctaRdv: "Записаться на визит",
      ctaAccess: "У меня уже есть доступ",
      badgeAccess: "Только по приглашению",
      badgeDocs: "11 документов",
      badgePayment: "Банковский перевод",
    },
    steps: {
      overline: "Процесс",
      title1: "4 шага,",
      title2: "ноль бумаг",
      description: "Больше не нужно бегать между секретариатом и почтой: всё происходит онлайн, и вы можете отслеживать каждый этап.",
      s1Title: "Первый контакт",
      s1Desc: "Заполните контактную форму официального сайта школы, указав несколько сведений о вашем ребёнке.",
      s2Title: "Приёмная встреча",
      s2Desc: "Администрация приглашает вас на встречу, чтобы обсудить образовательный проект и представить Lafayette.",
      s3Title: "Приглашение по почте",
      s3Desc: "После встречи вы получите персональную ссылку для активации вашего личного кабинета MyLafayette Admissions.",
      s4Title: "Досье и проверка",
      s4Desc: "Вы заполняете досье онлайн (11 документов, включая подтверждение перевода), школа подтверждает зачисление.",
    },
    docs: {
      overline: "Необходимые документы",
      title1: "11 документов для загрузки,",
      title2: "проверяются по очереди.",
      description: "Каждый документ проверяется секретариатом Lafayette. Вступительный взнос оплачивается банковским переводом, и **подтверждение перевода** является частью загружаемого досье.",
      validationBadge: "Проверка",
      validationTitle: "Документ за документом",
      validationDesc: "Если документ отклонён, администратор оставит комментарий для повторной загрузки.",
      facultatif: "По желанию",
      handoutNote: "Полное досье поступления и реквизиты школы (IBAN) выдаются вам лично во время первой встречи в школе.",
    },
    cta: {
      overline: "Готовы присоединиться к Lafayette?",
      titlePart1: "Начнём с",
      titlePart2: "первой встречи.",
      description: "Наша приёмная команда проведёт с вами первую беседу. Затем вы получите по электронной почте персональный доступ к MyLafayette Admissions, чтобы оформить досье и загрузить подтверждение перевода.",
      button: "Записаться на визит",
      buttonSecondary: "Войти",
    },
    footer: {
      schoolFull: "Lafayette International School",
      tagline: "Двуязычный колледж и лицей · Ницца",
      resources: "Ресурсы",
      official: "Официальный сайт Lafayette",
      requestMeeting: "Записаться на визит",
      familySpace: "Семейный кабинет",
      aboutTitle: "О нас",
      aboutText: "MyLafayette Admissions — это цифровое расширение приёма в Lafayette International School, доступное только для семей, прошедших встречу с администрацией.",
      rgpd: "Соответствует GDPR · Данные хранятся в Европе",
      copyright: "Lafayette International School — Все права защищены",
    },
    docList: {
      assurance_rc: "Школьная страховка / Гражданская ответственность",
      certificat_naissance: "Свидетельство о рождении",
      certificat_radiation: "Справка об отчислении из предыдущей школы",
      bulletins: "Школьные ведомости (3 последние)",
      id_pere: "Удостоверение личности — Отец",
      id_mere: "Удостоверение личности — Мать",
      id_enfant: "Удостоверение личности — Ребёнок",
      vaccinations: "Прививочная карта",
      iban: "Банковский счёт (IBAN)",
      preuve_virement: "Подтверждение оплаты вступительного взноса",
      dossier_signe: "Подписанное досье поступления",
    },
    login: {
      overline: "Вход",
      title: "С возвращением.",
      subtitle: "Войдите в досье поступления и следите за его статусом.",
      google: "Продолжить с Google",
      or: "или",
      email: "Email",
      emailPlaceholder: "parent@email.com",
      password: "Пароль",
      submit: "Войти",
      submitting: "Вход…",
      noAccount: "Ещё нет аккаунта?",
      createAccount: "Создать аккаунт",
      invitationInfo: "Доступ к MyLafayette предоставляется строго по приглашению. Если вы ещё не получили ссылку активации по email, свяжитесь с администрацией после первой встречи: collegelyceelafayette@gmail.com",
      sideOverline: "Семейный кабинет",
      sideTitle1: "Продолжайте досье",
      sideTitle2: "с того места, где остановились.",
    },
    register: {
      overline: "Только по приглашению",
      title: "Регистрация после первой встречи.",
      intro: "Доступ к MyLafayette Admissions",
      introBold: "предоставляется только семьям, прошедшим встречу",
      introEnd: "с администрацией Lafayette International School. Процесс выглядит так:",
      step1Title: "Первый контакт",
      step1Desc: "Заполните контактную форму официального сайта школы.",
      step2Title: "Приёмная встреча",
      step2Desc: "Администрация предлагает вам встречу (очно или онлайн) для обсуждения проекта обучения вашего ребёнка.",
      step3Title: "Приглашение по почте",
      step3Desc1: "После встречи вы получите письмо с",
      step3Desc2: "персональной ссылкой-приглашением",
      step3Desc3: "для активации вашего кабинета и оформления досье онлайн.",
      contactBox: "Записаться на визит",
      gotoContact: "Перейти к контактной форме",
      alreadyInvited: "Уже приглашены? Войти",
      secureNote: "Этот процесс защищает ваши данные и обеспечивает индивидуальное сопровождение.",
      sideOverline: "Lafayette International School",
      sideTitle1: "Французское совершенство,",
      sideTitle2: "международная открытость.",
      sideSub: "Строгий отбор, индивидуальное сопровождение.",
    },
    invite: {
      overline: "Приглашение Lafayette",
      title: "Активируйте семейный кабинет.",
      welcome: "Добро пожаловать",
      subtitle: "После вашей встречи с администрацией — ваш персональный доступ к MyLafayette Admissions.",
      openedFor: "Досье открыто для",
      email: "Email",
      emailHelp: "Email, привязанный к приглашению — не редактируется.",
      name: "Имя и фамилия контактного лица",
      password: "Пароль",
      submit: "Активировать мой кабинет",
      submitting: "Активация…",
      footer: "Вы получили эту ссылку, потому что школа провела с вами приёмную встречу. Создать аккаунт без этого приглашения невозможно.",
      verifying: "Проверка приглашения…",
      invalidTitle: "Приглашение недействительно",
      invalidNote: "Если вы считаете, что это ошибка, свяжитесь с администрацией Lafayette International School:",
      home: "На главную",
      already: "Вы уже вошли",
      alreadyDesc: "Это приглашение предназначено для незарегистрированного аккаунта.",
      goSpace: "Перейти в мой кабинет",
      sideTitle1: "Добро пожаловать",
      sideTitle2: "в новую главу.",
    },
    dash: {
      overline: "Кабинет родителя",
      hello: "Здравствуйте,",
      sub: "Следите за статусом досье и заполняйте недостающие этапы.",
      step1: "Сведения об ученике",
      step2: "Родители и семья",
      step3: "Документы",
      step4: "Проверка и отправка",
      previous: "Назад",
      next: "Далее",
      save: "Сохранить",
      saving: "Сохранение…",
      submit: "Отправить на проверку",
      lockedSubmitted: "Досье отправлено — редактирование закрыто.",
      missing: "недостаёт:",
      complete: "заполнены",
      completes: "заполнены",
      reviewIntro: "Проверьте, что все этапы заполнены, прежде чем отправлять досье на проверку.",
      reviewStudent: "Сведения об ученике",
      reviewParents: "Родители и семья",
      reviewDocs: "Документы",
      privacy: "Ваши данные зашифрованы и доступны только администрации школы.",
      uploadHere: "Загрузить",
      replace: "Заменить",
      docFacultatif: "По желанию",
      statusDraft: "Черновик",
      statusSubmitted: "Отправлено",
      statusValidated: "Подтверждено",
      statusRejected: "Требует исправлений",
      finalValidatedTitle: "Зачисление подтверждено",
      finalValidatedDesc: "Ваше досье полностью проверено администрацией Lafayette International School. Вскоре вы получите по электронной почте приглашение и информацию к началу учебного года.",
      finalPendingTitle: "Административная проверка",
      finalPendingDesc: "После отправки полного досье (включая подтверждение оплаты взноса) секретариат Lafayette проверяет каждый документ. После окончательного одобрения вы получите подтверждение зачисления.",
      rejectedTitle: "Комментарии администрации:",
      pillStatus: "Досье",
    },
    contact: {
      overline: "Связаться с нами",
      titlePart1: "Начнём",
      titlePart2: "разговор.",
      subtitle: "Хотите узнать больше о Lafayette International School? Заполните форму ниже или свяжитесь с нами напрямую. Администрация отвечает в течение 24 рабочих часов.",
      infoOverline: "Информация",
      infoTitle: "Lafayette International School",
      addressLabel: "Адрес",
      directions: "Маршрут в Google Maps",
      phoneLabel: "Телефон",
      phoneHours: "Пн-Вт-Чт-Пт: 7:30 – 18:00",
      emailLabel: "Email",
      emailReply: "Ответ в течение 24 рабочих часов",
      hoursLabel: "Часы работы",
      hoursMon: "Пн, Вт, Чт, Пт: 7:30 – 18:00",
      hoursWed: "Среда: 8:00 – 13:00",
      formOverline: "Форма обращения",
      formTitle: "Записаться на визит",
      formSub: "Заполните данные ниже — приёмная команда свяжется с вами для назначения первой встречи.",
      parentLabel: "Имя родителя / опекуна",
      parentPlaceholder: "Иван Иванов",
      emailFieldLabel: "Email",
      phoneFieldLabel: "Телефон",
      gradeLabel: "Желаемый класс",
      childDobLabel: "Дата рождения ребёнка",
      childGenderLabel: "Пол ребёнка",
      childGenderMale: "Мужской",
      childGenderFemale: "Женский",
      gradePlaceholder: "Выберите класс",
      messageLabel: "Сообщение",
      messagePlaceholder: "Расскажите кратко о вашем ребёнке и о вашем проекте…",
      submit: "Отправить запрос",
      submitting: "Отправка…",
      privacy: "Отправляя форму, вы соглашаетесь на связь с администрацией Lafayette International School. Ваши данные не передаются третьим лицам.",
      successTitle: "Запрос отправлен ✓",
      successDesc: "Спасибо! Ваш запрос получен. Ответ придёт на email в течение 24 рабочих часов.",
      successToast: "Запрос отправлен",
      backupEmailTitle: "Нет ответа?",
      backupEmailDesc: "В качестве резервного варианта вы можете отправить запрос напрямую по email — ваш почтовый клиент откроется с уже заполненным сообщением.",
      backupEmailButton: "Отправить копию по email",
      sendAnother: "Отправить ещё один запрос",
      errorRequired: "Заполните обязательные поля (имя, email, класс).",
      errorGeneric: "Произошла ошибка, попробуйте ещё раз.",
    },
  },
};
